module.exports = __webpack_public_path__ + "img/ippy-logo.8ff9c83.svg";